"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectHttpError = void 0;
const create_error_1 = require("../create-error");
const error_interfaces_1 = require("../types/error.interfaces");
const http_interfaces_1 = require("../types/http.interfaces");
/**
 * Our lowest level send is a wrapper around window.fetch. The promise returned from fetch()
 * won’t reject on HTTP error status even if the response is an HTTP 404 or 500. Instead,
 * it will resolve normally (with ok status set to false), and it will only reject on network
 * failure or if anything prevented the request from completing (with a TypeError of all things).
 * Other send decorators in our code base can return promises rejected with our own IError
 * objects. This function rejects the failed http requests.
 */
function rejectHttpError(send) {
    return async (request) => {
        const response = await send(request);
        if (response.status >= http_interfaces_1.Status.BAD_REQUEST) {
            throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.RequireStatusFailed, response, [
                http_interfaces_1.Status[response.status],
            ]);
        }
        return response;
    };
}
exports.rejectHttpError = rejectHttpError;
